module.exports = __webpack_public_path__ + "static/media/fm-icons-Users.db1b79bd.svg";